import {post} from "./http"

export const trackEvent = event => post("https://localhost:9600", event)
